import API from 'util/API';

// Admin or menuAdmin: public holidays maintained per state and year. GET /publicHolidays returns these
// before the cached government API data.
export const getHolidaySettings = async (state, year) => {
  const response = await API.get(
    `/publicHolidaySettings?state=${encodeURIComponent(state)}&year=${encodeURIComponent(year)}`
  );
  return response.data;
};

export const saveHolidaySettings = async (state, year, holidays) => {
  const response = await API.put('/publicHolidaySettings', { state, year, holidays });
  return response.data;
};
